import React from 'react'
import styled from 'styled-components'
import NukaCarousel from 'nuka-carousel'

import { Box, Row, Column, Text, Button } from './styled'
import * as Arrows from './svg/Arrows'

const Slide = ({ img, title, subtitle }) => (
  <Row
    height={['340px', '240px', '300px']}
    alignItems="center"
    justifyContent={['unset', 'center', 'center']}
    px={[0, '48px', '72px']}
    py={['32px', 0, 0]}
    flexDirection={['column', 'row', 'row']}
    bg="white"
  >
    <Box
      width={['120px', '140px', '192px']}
      mb={[5, 4, 0]}
      mr={[0, 6, '5rem']}
      ml={[0, 0, 3]}
    >
      <img
        src={img}
        width="100%"
        height="100%"
        css={{ borderRadius: '50%', userSelect: 'none', userDrag: 'none' }}
      />
    </Box>
    <Column maxWidth={['240px', '360px', '480px']}>
      <Text.p
        fontSize={[4, 4, 5]}
        lineHeight={1.34}
        fontWeight="medium"
        position="relative"
        textAlign={['center', 'left', 'left']}
        style={{ textIndent: '-0.5em' }}
      >
        “{title}”
      </Text.p>
      <Text.p
        mt={5}
        fontSize={[1, 3, 3]}
        color="gray2"
        textAlign={['center', 'left', 'left']}
      >
        {subtitle}
      </Text.p>
    </Column>
  </Row>
)

const ArrowButton = styled(Button)`
  user-select: none;
  border: none;
  padding: 8px;
  background: transparent;

  &:hover {
    opacity: 0.7;
  }
`

const Carousel = ({ slides }) => {
  return (
    <Row border={2} width="100%" mb={7} px={['12px', '32px', '48px']}>
      <NukaCarousel
        wrapAround={true}
        speed={400}
        dragging={false}
        heightMode="max"
        initialSlideWidth="100%"
        initialSlideHeight={300}
        renderCenterLeftControls={({ previousSlide }) => (
          <ArrowButton mb={['160px', 0, 0]} onClick={previousSlide}>
            <Arrows.Left />
          </ArrowButton>
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <ArrowButton mb={['160px', 0, 0]} onClick={nextSlide}>
            <Arrows.Right />
          </ArrowButton>
        )}
        renderBottomCenterControls={null}
      >
        {slides.map(props => (
          <Slide {...props} key={props.title} />
        ))}
      </NukaCarousel>
    </Row>
  )
}

export default Carousel
